// extracted by mini-css-extract-plugin
module.exports = {"ArticleText":"ArticleText_ArticleText__Di6GQ"};